import { render, staticRenderFns } from "./Cfg.vue?vue&type=template&id=070f9c41"
import script from "./Cfg.vue?vue&type=script&lang=js"
export * from "./Cfg.vue?vue&type=script&lang=js"
import style0 from "./Cfg.vue?vue&type=style&index=0&id=070f9c41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports